import fetchServer from "../../../fetchServer";

export default async function getRefundTicketRequests(params, cancelToken) {
  const {
    limit = 0,
    offset = 0,
    searchBy,
    keyword,
    filterBy,
    filterValue,
  } = params || {};

  var result = { return: 0, msg: "Failed fetching requests", data: [] };

  const searchPart = searchBy
    ? `&searchBy=orderId&keyword=${keyword}`
    : "";
  const filterPart = filterBy
    ? `&filterBy=${filterBy}&filterValue=${filterValue}`
    : "";

  await fetchServer({
    method: "GET",
    url: `/product/v1/refund/refundRequests?populate=account&populate=flightBooking&populate=conversation&limit=${limit}&offset=${offset}${searchPart}${filterPart}`,
    cancelToken,
  })
    .then((res) => {
      if (res) {
        if (res.status === 200) {
          result = { return: 1, msg: "Successfull", data: res.data.data };
        } else if (res?.data?.error) result["msg"] = res.data.error;
      }
    })
    .catch((err) => {
      console.log(err.message, err);
      if (err.message === "Network Error!") {
        result["msg"] = "Network Error!";
        result["error"] = "Please check your connection.";
      }
    });

  return result;
}
